(function () {

    'use strict';

    angular.module('iplusjs.utils.scrollToTop', [])
        .directive('iplusjsScrollToTop', scrollToTop);

    scrollToTop.$inject = [];
    function scrollToTop() {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {
                $scope.$watch($attrs.iplusjsScrollToTop, function (value) {
                    if (value) {
                        $element[0].scrollTop = 0;
                    }
                });
            }
        };
    }

})();
